import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';
import { pageList, pageText } from '../../content/publicPages';
import { usePublicPage } from '../../hooks/usePublicPage';

/**
 * Peerspace “If walls could talk” — editorial / blog-style cards (dummy).
 */
const MarketingStoriesBand = () => {
  const { saved, defaults } = usePublicPage('home');
  const stories = pageList(saved.stories, defaults.stories);
  return (
    <section className="bg-m-surface px-4 py-20 sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto w-full max-w-6xl">
        <div className="mb-12 flex flex-col gap-4 sm:mb-16 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-2xl">
            <h2 className="marketing-section-title mb-3 text-m-ink">
              {pageText(saved.stories_title, defaults.stories_title)}
            </h2>
            <p className="marketing-body-lg text-m-ink-muted">
              {pageText(saved.stories_body, defaults.stories_body)}
            </p>
          </div>
          <Link
            to="/blog"
            className="group inline-flex shrink-0 items-center gap-1.5 text-sm font-medium text-m-ink transition-opacity hover:opacity-70"
          >
            {pageText(saved.stories_link_label, defaults.stories_link_label)}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:gap-10">
          {stories.map((story) => (
            <Link
              key={story.id}
              to={story.href}
              className="group flex flex-col overflow-hidden rounded-2xl border border-m-border-light transition-colors hover:border-m-ink/30"
            >
              <div className="overflow-hidden">
                <img
                  src={story.image}
                  alt=""
                  className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-1 flex-col p-5 sm:p-6">
                <p className="mb-2 text-[11px] font-medium uppercase tracking-[0.14em] text-m-ink-faint">
                  {story.eyebrow}
                </p>
                <h3 className="mb-2 text-xl font-medium tracking-tight text-m-ink">
                  {story.title}
                </h3>
                <p className="marketing-body flex-1 text-m-ink-muted">{story.body}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-m-ink">
                  Keep reading
                  <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingStoriesBand;
